import React from "react";
import { IConfigStorage } from "../../rule-engine-core/Common/IConfigStorage";
import { FlowEditContext } from "../FlowEditContext";
import { AppGlueError } from "../../rule-engine-core/AppGlueError";
import { FlowStepData } from "../../rule-engine-core/Flow/Steps/FlowStepData";
import { FlowStepEditorRegistration } from "../Utilities/RegisterFlowEditor";
import { AutoBind } from "../../rule-engine-core/Common/AutoBind";
import { StateManager } from "../../rule-engine-core/Common/StateManager";
import { FlowStepSequence } from "../../rule-engine-core/Flow/Structure/FlowStepSequence";
import { IEditable } from "../../CommonUI/IEditable";

export abstract class BaseFlowStepEditor extends React.Component implements IConfigStorage, IEditable {
    abstract renderActionUI: () => JSX.Element;

    constructor() {
        super({}, {});
    }

    private _editContext?: FlowEditContext;

    get editContext(): FlowEditContext {
        if (!this._editContext) throw new AppGlueError("edit context not set");

        return this._editContext;
    }

    set editContext(value: FlowEditContext) {
        this._editContext = value;
    }

    get shouldShowDescription(): boolean {
        return this.getFlowStepData().shouldShowDescription;
    }

    set shouldShowDescription(value: boolean) {
        this.getFlowStepData().shouldShowDescription = value;
    }

    get description(): string {
        return this.getFlowStepData().description;
    }

    set description(value: string) {
        this.getFlowStepData().description = value;
    }

    get name(): string | undefined {
        return this.getFlowStepData().name;
    }

    set name(value: string | undefined) {
        this.getFlowStepData().name = value;
    }

    get _id(): string {
        return this.getFlowStepData()._id;
    }

    set _id(value: string) {
        this.getFlowStepData()._id = value;
    }

    get icon() {
        const icon = FlowStepEditorRegistration.getByTypeName(this.type)?.icon;
        return icon;
    }

    get type() {
        return this.getFlowStepData().__type!;
    }

    abstract getStorageData(): object;

    abstract setStorageData(data: object): void;

    abstract getFlowStepData(): FlowStepData;

    @AutoBind
    stepUpdate(): void {
        StateManager.changed(this);
        StateManager.changed(this.getFlowStepData());
        if (this.getFlowStepData().sequence)
            StateManager.propertyChanged(this.getFlowStepData().sequence!, FlowStepSequence.STEPS_CHANGED);
    }

    // forces refresh of entire designer (expensive)
    @AutoBind
    designerUpdate(): void {
        //        this.getFormContext()?.refreshDesigner();
    }

    abstract renderEditUI(): JSX.Element | null;
}
